function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "deterministic");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Website",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Products-Copy",
  transform: "translate(-281.000000, -844.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "deterministic",
  transform: "translate(281.000000, 844.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "left-range",
  transform: "translate(0.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 1,
  x2: 28,
  y2: 1,
  id: "Path",
  stroke: "#73868C",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  x1: 14,
  y1: 7,
  x2: 14.5,
  y2: 60.5,
  id: "Path",
  stroke: "#73868C",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#73868C",
  fillRule: "nonzero",
  points: "14 0 7.5 13 20.5 13"
})), /*#__PURE__*/React.createElement("text", {
  id: "f(n)",
  fill: "#73868C",
  fontFamily: "Helvetica",
  fontSize: 20,
  fontWeight: "normal"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 88
}, "f(n)")), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.000000, 109.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 28,
  y1: 56,
  x2: 0,
  y2: 56,
  id: "Path",
  stroke: "#73868C",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  x1: 14,
  y1: 50,
  x2: 14.5,
  y2: 0.5,
  id: "Path",
  stroke: "#73868C",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#73868C",
  fillRule: "nonzero",
  points: "14 57 20.6 44 7.6 44"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Arrows",
  transform: "translate(57.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-link"
}), /*#__PURE__*/React.createElement("g", {
  id: "arrow",
  transform: "translate(0.000000, 61.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#7CA1A6",
  fillRule: "nonzero",
  cx: 10,
  cy: 5,
  r: 4.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 10,
  y1: 14,
  x2: 10,
  y2: 43,
  id: "Path",
  stroke: "#7CA1A6",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#7CA1A6",
  strokeWidth: 3,
  points: "0.7 34 10 43.5 19.3 34"
})), /*#__PURE__*/React.createElement("g", {
  id: "arrow"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#7CA1A6",
  fillRule: "nonzero",
  cx: 10,
  cy: 5,
  r: 4.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 10,
  y1: 14,
  x2: 10,
  y2: 43,
  id: "Path",
  stroke: "#7CA1A6",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#7CA1A6",
  strokeWidth: 3,
  points: "0.7 34 10 43.5 19.3 34"
})), /*#__PURE__*/React.createElement("g", {
  id: "arrow",
  transform: "translate(0.000000, 123.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#7CA1A6",
  fillRule: "nonzero",
  cx: 10,
  cy: 5,
  r: 4.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 10,
  y1: 14,
  x2: 10,
  y2: 43,
  id: "Path",
  stroke: "#7CA1A6",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#7CA1A6",
  strokeWidth: 3,
  points: "0.7 34 10 43.5 19.3 34"
}))))));

var SvgScooterDeterministic = function SvgScooterDeterministic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "169px",
    viewBox: "0 0 78 169",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScooterDeterministic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scooter-deterministic.93f153a3.svg";
export { ForwardRef as ReactComponent };